<script lang="ts">
	import { Button, ButtonType } from '@repo/commons/components'

	interface Props {
		row: Record<string, string>
		onActionClicked: ((type: string, id: string) => void) | null
	}

	let { row, onActionClicked = null }: Props = $props()

	const handleClick = (id: string) => {
		onActionClicked?.('eye', id)
	}
</script>

<Button
	buttonText=""
	buttonType={ButtonType.TERTIARY_INVERSE}
	iconProps={{ name: 'eye', size: 'md', class: 'text-[#002C4D80]' }}
	onclick={() => handleClick(row.id)}
/>

<style>
	button {
		width: 32px;
		height: 32px;
	}
</style>
